import angular from 'angular';
import providerInformationList from './providerInformationList';

export default angular
  .module('components.providerInformationList', [])
  .component('providerInformationList', providerInformationList).name;
